<scitis-breadcrumb [breadcrumbRoutes]="routes"></scitis-breadcrumb>
<scitis-app-global-page-header>
  <div header-title>
    <scitis-page-header-logo-and-name
        [machineCategory]="pageGlobalParameters.machineCategory"
        [machineId]="pageGlobalParameters.machineId"
        [pageName]="pageGlobalParameters.pageName"
        [pageType]="pageGlobalParameters.pageType">

    </scitis-page-header-logo-and-name>
  </div>
  <ng-template #filterElement>
    <!--STATUS PAGE-->
    <scitis-status-event-page-actions [isAdminOrHigher]="isAdminOrHigher"
                                      [isAdminOrLower]="isAdminOrLower"
                                      [isTemplatePage]="isTemplatePage"
                                      [machineCategory]="machineCategory"
                                      [machineId]="pageGlobalParameters.machineId"
                                      [machineTag]="machineTag"
                                      [organizationId]="pageGlobalParameters.organizationId"
                                      [pageId]="pageGlobalParameters.pageId"
                                      [pageName]="pageGlobalParameters.pageName"
                                      [isLoading]="isLoading"
                                      [syncTemplatePage]="syncTemplatePage"
                                      [statusEventPageConfiguration]="statusEventPageConfiguration"
                                      class="page-functions">
    </scitis-status-event-page-actions>
  </ng-template>

</scitis-app-global-page-header>

<div class="page-content">
  <scitis-status-event-page
      [machineCategory]="pageGlobalParameters.machineCategory"
      [machineId]="pageGlobalParameters.machineId"
      [organizationId]="pageGlobalParameters.organizationId"
      [pageId]="pageGlobalParameters.pageId"
      [pageName]="pageGlobalParameters.pageName"
      [pageType]="pageGlobalParameters.pageType"
      [statusEventPageConfiguration]="statusEventPageConfiguration"
      [isTemplatePage]="isTemplatePage">
  </scitis-status-event-page>
</div>
